import { ExcludedGamesState } from '../models'

const initialState: ExcludedGamesState = {
  isLoading: false,
  hasError: false,
  error: '',
  wasDeleted: false,
  excludedGames: {
    _id: '',
    games: [],
    name: '',
  },
  currentGame: null,
  gamesList: [],
}

export default initialState
